import React from 'react';

import type { Props as FormattedTimeZoneProps } from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';

const LoginTimeZone: React.FC<FormattedTimeZoneProps> = (props) => (
  <FormattedTimeZone
    year="numeric"
    month="short"
    day="numeric"
    hour="2-digit"
    minute="2-digit"
    hour12={false}
    showTimeZone
    {...props}
  />
);

export default LoginTimeZone;
